import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./performanceApiClient";

export const listGoals = async (params = {}) =>
  getRequest("/goals", {
    params,
  });

export const getGoalById = async (goalId) => getRequest(`/goals/${goalId}`);

export const createGoal = async (payload) => postRequest("/goals", payload);

export const updateGoal = async (goalId, payload) =>
  putRequest(`/goals/${goalId}`, payload);

export const deleteGoal = async (goalId) => deleteRequest(`/goals/${goalId}`);

export const approveGoal = async (goalId, payload = {}) =>
  postRequest(`/goals/${goalId}/approve`, payload);

export const rejectGoal = async (goalId, payload = {}) =>
  postRequest(`/goals/${goalId}/reject`, payload);

export const submitGoalCheckin = async (goalId, payload) =>
  postRequest(`/goals/${goalId}/checkins`, payload);

export default {
  listGoals,
  getGoalById,
  createGoal,
  updateGoal,
  deleteGoal,
  approveGoal,
  rejectGoal,
  submitGoalCheckin,
};
